<template>

  <div class="message-box-root">

    <div

      v-if="showCaseModal && currentNotice"

      class="case-notice-modal"

    >

      <div class="case-notice-modal__mask"></div>

      <div class="case-notice-modal__panel">

        <div class="case-notice-modal__bg"></div>

        <img

          class="case-notice-modal__bell"

          src="./../../assets/img/lingdang.png"

          alt=""

        />

        <p class="case-notice-modal__close" @click.stop="closeCaseModal(false)">x</p>

        <h3 class="case-notice-modal__title">有新用户报案，请尽快解决！</h3>

       

        <button

          type="button"

          class="case-notice-modal__btn"

          @click.stop="closeCaseModal(true)"

        >

          立即查看

        </button>

      </div>

    </div>

    <!-- 须用模板按钮解锁：$alert 回调不在浏览器用户手势上下文内，授权无效 -->
    <div v-if="showAudioPermissionModal" class="case-audio-permission-modal">
      <div class="case-audio-permission-modal__mask"></div>
      <div class="case-audio-permission-modal__panel">
        <h3 class="case-audio-permission-modal__title">开启新案件提示音</h3>
        <p class="case-audio-permission-modal__desc">
          浏览器限制了媒体自动播放。请点击下方按钮开启，开启后新案件将自动播放提示音，无需再次点击屏幕。
        </p>
        <button
          type="button"
          class="case-audio-permission-modal__btn"
          @click="onConfirmAudioPermission"
        >
          开启提示音
        </button>
      </div>
    </div>

    <audio

      ref="caseAudio"

      src="./static/img/baoan.mp3"

      loop

      hidden

    ></audio>

  </div>

</template>



<script>

import { getLunxun, getLunxunRead } from "@/views/axios/api.js";

import constants from "@/util/constants.js";

import langtrans from "./message_box.vue.trans.js";

import canAutoPlay from "can-autoplay";

export default {

  data() {

    return {

      timer: null,

      list: [],

      showCaseModal: false,

      currentNotice: null,

      lastPollAt: 0,

      audioRetryTimer: null,

      audioPlayAttempts: 0,

      /** 当前会话是否已解锁提示音播放 */
      audioUnlocked: false,

      /** 是否已弹出过进入页权限引导 */
      audioPermissionPrompted: false,

      /** 是否显示「开启提示音」权限弹层 */
      showAudioPermissionModal: false,

      token: (function () {

        try {

          var storage = JSON.parse(window.localStorage.getItem("data") || "{}");

          return storage.data || "";

        } catch (e) {

          return "";

        }

      })(),

    };

  },

  computed: {

    languageIndex() {

      return this.$store.state.language;

    },

  },

  methods: {

    langtrans() {

      return langtrans;

    },

    lookover(data) {

      window.open(data.url);

    },

    /**
     * 接口是否成功
     * @param {string|number} code
     * @returns {boolean}
     */
    isApiSuccess(code) {
      var resultCode = Number(code);
      return resultCode === 0 || resultCode === 200026;
    },

    /**
     * 读取通知 type 字段
     * @param {Object} notice
     * @returns {string|number|undefined}
     */
    getNoticeType(notice) {
      if (!notice) return undefined;
      if (notice.type !== undefined && notice.type !== null && notice.type !== "") {
        return notice.type;
      }
      if (notice.noticeType !== undefined && notice.noticeType !== null) {
        return notice.noticeType;
      }
      return undefined;
    },

    /**
     * 是否为新案件通知（type 80/90）
     * @param {string|number} type
     * @returns {boolean}
     */
    isNewCaseNotice(type) {
      var noticeType = Number(type);
      return noticeType === 80 || noticeType === 90;
    },

    /**
     * 统一整理通知列表结构
     * @param {*} obj
     * @returns {Array}
     */
    normalizeNotices(obj) {
      if (!obj) return [];
      if (Array.isArray(obj)) return obj;
      if (typeof obj === "object" && obj.id) return [obj];
      return [];
    },

    /**
     * 是否指挥中心账号（需持续轮询）
     * @returns {boolean}
     */
    isCommandCenterUser() {
      try {
        var usertypeData = JSON.parse(window.localStorage.getItem("usertype") || "{}").data;
        if (Number(usertypeData) === 1) return true;
      } catch (e) {}
      try {
        var insti = JSON.parse(window.localStorage.getItem("insti") || "{}");
        if (Number(insti.type) === 1) return true;
      } catch (e) {}
      return false;
    },

    /**

     * 从通知列表中取第一条新案件通知

     * @param {Array} notices

     * @returns {Object|null}

     */

    findNewCaseNotice(notices) {

      if (!notices || !notices.length) return null;

      for (var i = 0; i < notices.length; i++) {

        var item = notices[i];

        if (item && item.id && this.isNewCaseNotice(this.getNoticeType(item))) {

          return item;

        }

      }

      return null;

    },

    /**

     * 处理新案件通知：仅 type 80/90 弹框并播放提示音

     * @param {Object} notice

     * @param {Array} allNotices

     */

    handleNewCaseNotice(notice, allNotices) {

      if (!notice || !notice.id || !this.isNewCaseNotice(this.getNoticeType(notice))) {

        return;

      }

      this.list = allNotices.filter((item) => {

        return this.isNewCaseNotice(this.getNoticeType(item));

      });

      var isSameNotice =

        this.showCaseModal &&

        this.currentNotice &&

        this.currentNotice.id === notice.id;

      if (!isSameNotice) {

        this.openCaseModal(notice);

      }

      this.tryPlayCaseAudio();

    },

    /**
     * 是否允许播放新案件提示音
     * @returns {boolean}
     */
    canPlayCaseAudioNow() {

      return (

        this.showCaseModal &&

        this.currentNotice &&

        this.isNewCaseNotice(this.getNoticeType(this.currentNotice))

      );

    },

    /**
     * 清除音频重试定时器
     */
    clearAudioRetry() {

      if (this.audioRetryTimer) {

        clearTimeout(this.audioRetryTimer);

        this.audioRetryTimer = null;

      }

    },

    /**
     * 自动播放失败后定时重试
     */
    scheduleAudioRetry() {

      var self = this;

      if (!self.canPlayCaseAudioNow()) {

        self.clearAudioRetry();

        return;

      }

      if (self.audioPlayAttempts >= 6) {

        self.clearAudioRetry();

        if (self.audioUnlocked) {

          self.audioUnlocked = false;

          try {

            sessionStorage.removeItem("caseAudioUnlocked");

          } catch (e) {}

        }

        self.showAudioPermissionDialog(true);

        return;

      }

      self.clearAudioRetry();

      self.audioRetryTimer = setTimeout(function () {

        self.audioPlayAttempts++;

        self.playCaseAudio(true);

      }, 1000);

    },

    /**
     * 标记提示音已解锁
     * @param {boolean} persist 是否写入 sessionStorage
     */
    markAudioUnlocked(persist) {
      this.audioUnlocked = true;
      if (persist) {
        try {
          sessionStorage.setItem("caseAudioUnlocked", "1");
        } catch (e) {}
      }
    },

    /**
     * 进入页面时检测浏览器是否限制自动播放
     */
    checkAudioPermissionOnEnter() {
      if (!this.isCommandCenterUser()) return;

      var self = this;

      try {
        if (sessionStorage.getItem("caseAudioUnlocked") === "1") {
          self.verifyCaseAudioAutoplay();
          return;
        }
      } catch (e) {}

      canAutoPlay
        .audio()
        .then(function ({ result }) {
          if (result === true) {
            self.verifyCaseAudioAutoplay();
          } else {
            self.showAudioPermissionDialog(false);
          }
        })
        .catch(function () {
          self.showAudioPermissionDialog(false);
        });
    },

    /**
     * 用实际提示音文件验证能否自动播放
     */
    verifyCaseAudioAutoplay() {
      var audioEl = this.$refs.caseAudio;
      if (!audioEl) {
        this.showAudioPermissionDialog(false);
        return;
      }

      var self = this;
      if (audioEl.readyState < 2) {
        audioEl.load();
      }
      var savedVolume = audioEl.volume;
      audioEl.volume = 0;

      var playPromise = audioEl.play();
      if (!playPromise || !playPromise.then) {
        audioEl.volume = savedVolume;
        self.markAudioUnlocked(true);
        return;
      }

      playPromise
        .then(function () {
          audioEl.pause();
          audioEl.currentTime = 0;
          audioEl.volume = savedVolume;
          self.markAudioUnlocked(true);
        })
        .catch(function () {
          audioEl.volume = savedVolume;
          self.showAudioPermissionDialog(false);
        });
    },

    /**
     * 显示「开启提示音」权限弹层
     * @param {boolean} fromCase 是否因来案件播放失败而弹出
     */
    showAudioPermissionDialog(fromCase) {
      if (this.audioUnlocked) return;
      if (!fromCase && this.audioPermissionPrompted) return;
      if (!fromCase) {
        this.audioPermissionPrompted = true;
      }
      this.showAudioPermissionModal = true;
    },

    /**
     * 用户点击「开启提示音」（须为模板 @click，保证浏览器用户手势有效）
     */
    onConfirmAudioPermission() {
      var audioEl = this.$refs.caseAudio;
      if (!audioEl) return;

      var self = this;
      audioEl.volume = 1;
      audioEl.muted = false;
      if (audioEl.readyState < 2) {
        audioEl.load();
      }

      var keepPlaying = self.showCaseModal && self.canPlayCaseAudioNow();
      var playPromise = audioEl.play();

      if (!playPromise || !playPromise.then) {
        self.finishAudioUnlock(keepPlaying);
        return;
      }

      playPromise
        .then(function () {
          self.finishAudioUnlock(keepPlaying);
        })
        .catch(function () {
          self.$message.warning("开启失败，请再试一次");
        });
    },

    /**
     * 完成提示音权限解锁
     * @param {boolean} keepPlaying 是否保持播放（来案件时弹层叠加场景）
     */
    finishAudioUnlock(keepPlaying) {
      var self = this;
      var audioEl = this.$refs.caseAudio;

      this.showAudioPermissionModal = false;
      this.markAudioUnlocked(true);
      this.$message.success("提示音权限已开启");

      if (!keepPlaying && audioEl) {
        window.setTimeout(function () {
          if (!self.showCaseModal) {
            audioEl.pause();
            audioEl.currentTime = 0;
          }
        }, 150);
      }
    },

    /**
     * 尝试播放提示音（弹框出现后调用，含自动重试）
     */
    tryPlayCaseAudio() {

      var self = this;

      self.audioPlayAttempts = 0;

      self.$nextTick(function () {

        self.playCaseAudio(false);

      });

    },

    /**
     * 提示音是否正在播放
     * @returns {boolean}
     */
    isCaseAudioPlaying() {

      var audioEl = this.$refs.caseAudio;

      return !!(audioEl && !audioEl.paused);

    },

    /**
     * 播放新案件提示音（仅当前为新案件弹框时）
     * @param {boolean} isRetry 是否为自动重试
     */
    playCaseAudio(isRetry) {

      if (!this.canPlayCaseAudioNow()) {

        return;

      }

      var audioEl = this.$refs.caseAudio;

      if (!audioEl) return;

      var self = this;

      if (audioEl.readyState < 2) {

        audioEl.load();

      }

      var playPromise = audioEl.play();

      if (!playPromise || !playPromise.then) {

        return;

      }

      playPromise

        .then(function () {

          self.audioPlayAttempts = 0;

          self.clearAudioRetry();

          self.markAudioUnlocked(true);

        })

        .catch(function () {

          if (!self.audioUnlocked) {

            self.showAudioPermissionDialog(true);

            return;

          }

          self.scheduleAudioRetry();

        });

    },

    /**

     * 打开新案件弹框

     * @param {Object} notice

     */

    openCaseModal(notice) {

      if (!notice || !this.isNewCaseNotice(this.getNoticeType(notice))) {

        return;

      }

      this.currentNotice = notice;

      this.showCaseModal = true;

    },

    /**

     * 关闭新案件弹框

     * @param {boolean} openDetail 是否打开详情

     */

    closeCaseModal(openDetail) {

      if (!this.currentNotice) {

        this.showCaseModal = false;

        this.pauseCaseAudio();

        return;

      }

      this.pauseCaseAudio();

      this.setRead(this.currentNotice, 0, openDetail);

    },

    /**

     * 停止新案件提示音

     */

    pauseCaseAudio() {

      this.clearAudioRetry();

      var audioEl = this.$refs.caseAudio;

      if (audioEl) {

        audioEl.pause();

        audioEl.currentTime = 0;

      }

    },

    lunxun() {

      var now = new Date().getTime();

      if (this.lastPollAt && this.lastPollAt > now - 2000) {

        return;

      }

      var t = null;

      if (window.localStorage.getItem("data")) {

        try {

          t = JSON.parse(window.localStorage.getItem("data")).data;

        } catch (e) {

          t = null;

        }

      }

      if (t == null) {

        return;

      }

      this.lastPollAt = now;

      getLunxun({ token: t })

        .then((res) => {

          if (!res.data || !this.isApiSuccess(res.data.code)) {

            return;

          }

          var notices = this.normalizeNotices(res.data.obj);

          if (!notices.length) {

            return;

          }

          var newCaseNotice = this.findNewCaseNotice(notices);

          if (newCaseNotice) {

            this.handleNewCaseNotice(newCaseNotice, notices);

            return;

          }

          var notice = notices[0];

          if (!notice || !notice.id) return;

          var exists = false;

          this.list.forEach((item) => {

            if (item.id == notice.id) {

              exists = true;

            }

          });

          if (!exists) {

            this.list.push(notice);

          }

        })

        .catch((err) => {

          console.log(err);

        });

    },

    setRead(dataArr, index, status) {

      getLunxunRead({

        token: this.token,

        noticeId: dataArr.id,

      })

        .then((res) => {

          if (this.isApiSuccess(res.data.code)) {

            if (status) {

              this.lookover(dataArr);

            }

            this.list = this.list.filter((item) => {

              return item.id !== dataArr.id;

            });

            this.showCaseModal = false;

            this.currentNotice = null;

          }

          this.pauseCaseAudio();

        })

        .catch((err) => {

          console.log(err);

          this.pauseCaseAudio();

        });

    },

    setTime(time) {

      return constants.time(time);

    },

    /**
     * 本地开发：模拟新案件弹框（不依赖接口）
     */
    debugShowCaseModal() {
      var mockNotice = {
        id: "dev-test-" + Date.now(),
        type: 80,
        url: window.location.href,
      };
      this.handleNewCaseNotice(mockNotice, [mockNotice]);
    },

    /**
     * 启动轮询；弹框与音频检测分离
     */
    startTimer() {

      var pollTick = () => {

        this.lunxun();

      };

      pollTick(false);

      if (this.isCommandCenterUser()) {

        this.timer = setInterval(pollTick, 3000);

      }

    },

  },

  mounted() {

    this.startTimer();

    this.$nextTick(() => {

      this.checkAudioPermissionOnEnter();

    });

    if (process.env.NODE_ENV === "development") {
      window.__debugShowCaseModal = () => {
        this.debugShowCaseModal();
      };
      console.info("[message_box] 本地测试弹框: window.__debugShowCaseModal()");
    }

  },

  beforeDestroy() {

    if (this.timer != null) {

      clearInterval(this.timer);

    }

    this.clearAudioRetry();

    this.pauseCaseAudio();

    if (process.env.NODE_ENV === "development") {
      delete window.__debugShowCaseModal;
    }

  },

};

</script>



<!-- 弹框样式不用 scoped，避免挂到 body 或层级问题导致不可见 -->

<style>

.message-box-root {

  position: fixed;

  top: 0;

  left: 0;

  width: 0;

  height: 0;

  overflow: visible;

  z-index: 99999;

  pointer-events: none;

}



.case-notice-modal {

  position: fixed;

  top: 0;

  left: 0;

  width: 100vw;

  height: 100vh;

  z-index: 99999;

  pointer-events: auto;

}



.case-notice-modal__mask {

  position: absolute;

  top: 0;

  left: 0;

  width: 100%;

  height: 100%;

  background-color: rgba(0, 0, 0, 0.45);

}



.case-notice-modal__panel {

  position: absolute;

  top: 50%;

  left: 50%;

  width: 400px;

  height: 400px;

  margin-top: -200px;

  margin-left: -200px;

  background: #fff;

  border-radius: 5px;

  overflow: hidden;

}



.case-notice-modal__bg {

  width: 100%;

  height: 240px;

  background: #cdeefe;

}



.case-notice-modal__bell {

  position: absolute;

  top: 60px;

  left: 50%;

  width: 130px;

  margin-left: -65px;

  animation: case-notice-bell 0.4s 0s infinite;

  transform-origin: top center;

}



.case-notice-modal__close {

  position: absolute;

  top: 10px;

  right: 10px;

  width: 20px;

  height: 20px;

  border-radius: 50%;

  background: #fff;

  text-align: center;

  line-height: 20px;

  cursor: pointer;

  margin: 0;

}



.case-notice-modal__title {

  text-align: center;

  line-height: 70px;

  margin: 0;

  font-size: 16px;

  color: #333;

}

.case-notice-modal__btn {

  border: none;

  background: #00abfa;

  padding: 10px 50px;

  color: #fff;

  border-radius: 3px;

  display: block;

  margin: 20px auto 0;

  cursor: pointer;

  font-size: 14px;

}

.case-audio-permission-modal {

  position: fixed;

  top: 0;

  left: 0;

  width: 100vw;

  height: 100vh;

  z-index: 100000;

  pointer-events: auto;

}

.case-audio-permission-modal__mask {

  position: absolute;

  top: 0;

  left: 0;

  width: 100%;

  height: 100%;

  background-color: rgba(0, 0, 0, 0.5);

}

.case-audio-permission-modal__panel {

  position: absolute;

  top: 50%;

  left: 50%;

  width: 420px;

  margin-left: -210px;

  margin-top: -120px;

  background: #fff;

  border-radius: 6px;

  padding: 24px 28px 28px;

  box-sizing: border-box;

}

.case-audio-permission-modal__title {

  margin: 0 0 12px;

  font-size: 18px;

  color: #333;

  text-align: center;

}

.case-audio-permission-modal__desc {

  margin: 0 0 20px;

  font-size: 14px;

  line-height: 1.6;

  color: #666;

  text-align: center;

}

.case-audio-permission-modal__btn {

  display: block;

  width: 100%;

  border: none;

  background: #00abfa;

  color: #fff;

  font-size: 15px;

  padding: 12px 0;

  border-radius: 4px;

  cursor: pointer;

}



@keyframes case-notice-bell {

  0%,

  65% {

    transform: rotate(0deg);

  }

  70% {

    transform: rotate(6deg);

  }

  75% {

    transform: rotate(-6deg);

  }

  80% {

    transform: rotate(6deg);

  }

  85% {

    transform: rotate(-6deg);

  }

  90% {

    transform: rotate(6deg);

  }

  95% {

    transform: rotate(-6deg);

  }

  100% {

    transform: rotate(0deg);

  }

}

</style>





// WEBPACK FOOTER //
// src/components/Tips_box/message_box.vue